import { Container, Row, Col, Card } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Pagination from '../../component/pagination';
import { ContextAPI } from '../../ContextAPI/ContextAPI';

const Blog = () => {
    const { data } = ContextAPI();

    const createSlug = (header) => {
        return header
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
            .replace(/\s+/g, '-') // Replace spaces with hyphens
            .replace(/-+/g, '-') // Remove consecutive hyphens
            .trim();
    };

    const formatDate = (dateStr) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateStr).toLocaleDateString('en-US', options);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const blogOverviewSchema = {
        "@context": "https://schema.org",
        "@type": "Blog",
        "headline": "Blog | Gautam Solar",
        "description": "Explore our latest blog posts about various topics on our website.",
        "url": "https://www.gautamsolar.com/blog/",
        "mainEntityOfPage": "https://www.gautamsolar.com/blog/",
        "webPage": {
            "@type": "WebPage",
            "url": "https://www.gautamsolar.com/blog/"
        }
    };

    return (
        <>
            <Helmet>
                <title>The Solar Panel Company Blogs</title>
                <meta name="description" content="Browse the solar panel company blogs from Gautam Solar, where industry expertise meets practical insights. Read posts on ‘Top Solar PV Module Manufacturing Companies in 2025’, ‘Advantages of TOPCon Solar Panels’, and more. Stay ahead with deep dives into PM‑KUSUM schemes, CUF optimization, rooftop awareness, and India’s solar rise." />

                <meta name='keywords' content='solar panel company near me, the solar panel company blogs, top solar power companies, solar system installation company' />

                <link rel="canonical" href="https://gautamsolar.com/blog/" />
                <script type="application/ld+json">
                    {JSON.stringify(blogOverviewSchema)}
                </script>
            </Helmet>
                
                <h1 className='visually-hidden'>Gautam Solar Blog</h1>

            <Container className="mt-5">
                <Row xs={1} md={2} lg={3} className="g-4">
                    {data.length ? data.map(blog => (
                        <Col key={blog.UUID} className="mb-4">
                            <Card className="h-100">


                                <Link to={`/${createSlug(blog.Header)}/`} className="card-link">
                                    <Card.Img variant="top" src={blog.ImageURL} alt={blog.Header} loading="lazy" />
                                </Link>
                               
                                <Card.Body>
                                    <Link to={`/${createSlug(blog.Header)}/`} className="card-link">
                                        <Card.Title style={{ color: "black" }}>{blog.Header}</Card.Title>
                                    </Link>

                                    <Link
                                        to={`/${createSlug(blog.Header)}/`}
                                        onClick={() => {
                                            localStorage.setItem('CardData', JSON.stringify(blog))
                                        }}
                                        className="elementor-post__read-more"
                                        aria-label={`Read more about ${blog.Header}`}
                                    >
                                        Read More »
                                    </Link>
                                </Card.Body>
                                <Card.Footer>
                                    <span className="elementor-post-date">{formatDate(blog.CreatedOn)}</span>
                                </Card.Footer>
                            </Card>
                        </Col>
                    )) : ""}
                </Row>
                <Pagination />
            </Container>
        </>
    );
};

export default Blog;



